<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">减除费用扣除确认</li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
        v-if="$judge_auth('17')"
      >
        从税局更新数据(无需勾选列表数据)
      </el-button>
      <el-button
        type="warning"
        :icon="Upload"
        link
        @click="onPush"
        v-if="$judge_auth('18')"
      >
        将数据更新至税局
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click.stop="state.showLog = true"
        v-if="$judge_auth('19')"
      >
        操作记录
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-radio-group v-model="state.params.is_push" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="1">已更新</el-radio-button>
        <el-radio-button :value="0">待更新</el-radio-button>
      </el-radio-group>
      <el-select
        v-model="state.params.skssnd"
        placeholder="年份"
        style="width: 100px"
        :clearable="false"
      >
        <el-option
          v-for="item in 5"
          :key="item"
          :label="
            $dayjs()
              .subtract(item - 1, 'year')
              .format('YYYY')
          "
          :value="
            $dayjs()
              .subtract(item - 1, 'year')
              .format('YYYY')
          "
        >
        </el-option>
      </el-select>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.tax_bureau_id"
        placeholder="税局"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.taxbureau_data"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadTaxBureau()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-select
        v-model="state.params.kcbs"
        placeholder="是否按6万扣除"
        style="width: 140px"
      >
        <el-option label="是" value="是" />
        <el-option label="否" value="否" />
      </el-select>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="姓名、证件号、手机号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="xm"
          label="姓名"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          width="120"
          fixed
        />
        <el-table-column
          label="手机号"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          width="120"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="手机号"
              @click="$onCopy(row.lxdh)"
            >
              {{ row.lxdh }}
            </text>
          </template>
        </el-table-column>
        <el-table-column label="证件号" width="180">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.zzhm)"
            >
              {{ row.zzhm }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="更新时间"
          prop="update_time"
          width="180"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="状态"
          prop="status"
          sortable="status"
          width="100"
        >
          <template #default="{ row }">
            <ul
              :style="{ color: row.declare_status == 0 ? '#1e90ff' : '#080' }"
            >
              {{
                row.declare_status == 0 ? "待更新" : "已更新"
              }}
            </ul>
          </template>
        </el-table-column>

        <el-table-column
          prop="customer_name"
          label="所属客户"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          :formatter="$tab_TextFormat"
          width="180"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="统一社会信用代码"
              @click="$onCopy(row.unified_social_credit_identifier)"
            >
              {{ row.unified_social_credit_identifier }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          prop="push_status"
          label="是否按6万扣除"
          width="140"
          align="center"
          fixed="right"
        >
          <template #default="{ row }">
            <div @click.stop="">
              <el-switch
                v-model="row.kcbs"
                inline-prompt
                active-text="是"
                active-color="#1e90ff"
                inactive-text="否"
                inactive-color="#f00"
                active-value="是"
                inactive-value="否"
                style="--el-switch-off-color: #f00"
                @change="onKcbsChange(row)"
                :disabled="!$judge_auth('231')"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="gj"
          label="国籍(地区)"
          :formatter="$tab_TextFormat"
          width="100"
          align="center"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          v-if="$judge_auth('229')"
        >
          <template #default="{ row }">
            <el-button
              type="danger"
              link
              icon="Delete"
              @click.stop="onDelete(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新减除费用"
        @close="state.showAgent = false"
      >
        <c_Agent
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
          :skssnd="state.params.skssnd"
        ></c_Agent>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_DeductionAmountLog :id="state.selectId"></c_DeductionAmountLog>
    </el-drawer>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_customer_select,
  data_taxbureau_select,
  data_withholdingagent_select,
} from "@/http/data";
import {
  deductionamount_list,
  deductionamount_push,
  deductionamount_del,
  deductionamount_update,
} from "@/http/deductionamount";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";
import { confirm_func } from "@/utils/qFormat";

import c_Agent from "./SelectWithholdingAgent.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  components: {
    c_Agent,
  },
  setup() {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      withholding_agent_arr: [],
    });
    onMounted(() => {
      state.params.skssnd = dayjs().format("YYYY");
      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoadTaxBureau();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      deductionamount_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //扣除标准改变事件
    const onKcbsChange = (row) => {
      ElMessageBox.confirm(
        `您确定将员工<strong style='color:#1e90ff'>${
          row.xm
        }</strong>的扣除标准改为${
          row.kcbs == "是"
            ? '<strong style="color:#080">按6万扣除'
            : '<strong style="color:#f00">不按6万扣除'
        }</strong>吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const data = { id: row.id, kcbs: row.kcbs };
          deductionamount_update(data)
            .then((res) => {
              if (res.status == 200)
                ElMessage({
                  type: "success",
                  grouping: true,
                  message: res.data.msg,
                });
            })
            .catch(() => {
              row.kcbs = row.kcbs == "是" ? "否" : "是";
            });
        })
        .catch(() => {
          row.kcbs = row.kcbs == "是" ? "否" : "是";
        });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      state.params.skssnd = dayjs().format("YYYY");
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //从税局更新数据
    const onPush = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要更新的数据",
          grouping: true,
        });
        return false;
      }
      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${rows.length}</strong>条数据，是否立即<strong style='color:#ffa500'>更新至税局</strong>？`,
        "更新提醒",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定更新",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        deductionamount_push({ id: rows.map((m) => m.id).join(",") }).then(
          (res) => {
            if (res.status == 200) {
              ElMessage.success(res.data.msg);
              onLoad();
            }
          }
        );
      });
    };

    //删除
    const onDelete = (id) => {
      confirm_func(deductionamount_del, { id }, onLoad);
    };

    //从税局更新数据确认事件
    const onSelectConfirm = () => {
      state.showAgent = false;
      onLoad();
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadWithholdingAgent,
      onLoadTaxBureau,
      onDelete,
      onPush,
      onRowClick,
      onSelectConfirm,
      onKcbsChange,
    };
  },
};
</script>
<style scoped></style>
